import { useState } from 'react';

const faqItems = [
  {
    q: '夫妻影院上的电影真的免费吗？需要注册吗？',
    a: '是的，夫妻影院所有夫妻电影与二人世界电影内容完全免费，无需注册登录即可直接观看。我们坚持免费高清在线观看不缓冲的承诺，让每一对夫妻和情侣都能无障碍享受高品质的浪漫电影推荐。',
  },
  {
    q: '影片画质如何？播放会卡顿吗？',
    a: '全站影片均采用高清片源，支持流畅播放。我们部署了多节点CDN加速，确保绝大多数网络环境下都能实现高清在线观看不缓冲的体验。如遇网络波动，播放器会自动调整清晰度以保证流畅度。',
  },
  {
    q: '更新频率是怎样的？如何知道上新了？',
    a: '夫妻影院保持每日更新的运营节奏，编辑团队持续追踪全球最新浪漫电影推荐。你可以关注页面顶部的「最新快讯」区域获取实时上片信息，也可以收藏本站随时回来查看新内容。',
  },
  {
    q: '手机和平板可以看吗？',
    a: '完全可以。夫妻影院已全面适配手机、平板和电脑端，在任何设备上都能获得良好的观影体验。躺在床上用手机看，或者投屏到电视上享受大屏二人世界，都很方便。',
  },
  {
    q: '如何推荐我想看的电影？',
    a: '非常欢迎你的推荐！你可以通过页面中的「联系我们」区域提交你想看的影片名称或类型。我们的编辑团队会定期整理大家的心愿单，并优先安排上架最受期待的夫妻必看影视内容。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
              答疑解惑
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              常见问题
            </h2>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                    {item.q}
                  </h3>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-400"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIdx === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 md:px-6 pb-5 text-sm text-foreground-500 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}